import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	BUTTON_SUBMIT: 'button[type=submit]',
};

export default class HtmlForm extends WebComponent {

	constructor(props) {
		super(props);
	}

	didMount() {
		this.buttonSubmitElement = this.element.querySelector(fragments.BUTTON_SUBMIT);
		if(this.buttonSubmitElement !== null) {
			this.buttonSubmitElement.addEventListener('click', (e) => {
				this.disabledButton(e);
			});
			// this.buttonSubmitElement.addEventListener('keydown', (e) => {
			// 	if ((e.which || e.keyCode) === 13) {
			// 		e.target.click();
			// 	}
			// });
		}
	}

	disabledButton = (e) => {
		const {
			messages,
		} = this.props;
		const curLang = this.getHtmlLang();
    e.target.classList.add('disabled');
		e.target.innerText = messages[curLang].send;
	};

	getHtmlLang = () => document.getElementsByTagName('html')[0].getAttribute('lang');
}

HtmlForm.defaultProps = {
	messages: {
		cs: {
			send: 'Odesílám...',
		},
		en: {
			send: 'Sending...',
		},
	},
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/HtmlForm.js